var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cards cffm",staticStyle:{"display":"none"}},[_c('div',{staticClass:"card-left"},[_c('CardLeft')],1),_c('div',{staticClass:"card-center"},[_c('CardCenter')],1),_c('div',{staticClass:"card-right"},[_c('CardRight')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }